import { render, staticRenderFns } from "./BoxTrafficPowerHourByFloor.vue?vue&type=template&id=d7435ea4&"
import script from "./BoxTrafficPowerHourByFloor.vue?vue&type=script&lang=js&"
export * from "./BoxTrafficPowerHourByFloor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QBtnToggle,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QTooltip,QBtnToggle,QInnerLoading,QSpinnerTail})
